import React from "react";
import {connect} from "react-redux";
import CaseDuplicate, {CaseDuplicateProps} from "./CaseDuplicate.tsx";

const CaseDuplicateFromState = (props: CaseDuplicateProps) => {
  return <CaseDuplicate {...props} />;
}

const mapStateToProps = (state) => {
  return {
    currentAccount: state.caseForms.caseHeader.policyInfo.customerInfo,
    surveyAddress: state.caseForms.caseHeader.policyInfo.surveyAddress,
    currentInspectionType: state.caseForms.caseHeader.caseInfo.currentInspectionType,
    originalInspectionType: state.caseForms.caseHeader.caseInfo.originalInspectionType,
    specialAttentionNotes: state.caseForms.caseHeader.caseInfo.webNotes,
  };
};

export default connect(mapStateToProps)(CaseDuplicateFromState);
